import styled from 'styled-components';

import { rem } from '@vimeo/bokeh';

export const LinkContainer = styled.div`
  font-size: ${rem(14)};
  margin-top: ${rem(8)};
  padding: ${rem(11)} ${rem(16)};
  text-align: center;
  font-style: normal;
  font-weight: 700;
  line-height: ${rem(17.64)};
  width: 100%;

  a:after {
    content: none;
  }

  a {
    text-decoration: underline !important;
  }
`;
